import { useNavigationStore } from '@/stores/navigation'

export const setLoadingState = (bool) => {
    const navigation = useNavigationStore();
    navigation.setLoadingState(bool)
};

export const setNavigationHeaderTitle = (title) => {
    const navigation = useNavigationStore();
    navigation.setNavHeaderTitle(title)
};